import style from './LoadPages.module.css';

const LoadPages = ({}) => {
  return (
    <div className={style.loading03}>
      <span>O</span>
      <span>n</span>
      <span>l</span>
      <span>i</span>
      <span>n</span>
      <span>e</span>
      <span>D</span>
      <span>a</span>
      <span>t</span>
      <span>i</span>
      <span>n</span>
      <span>g</span>
    </div>
  );
};

export default LoadPages;
